import { Injectable } from '@angular/core';
import { StatefulService } from '@app/service/stateful.service';
import { ApplicationApiService } from '@workflow/ecp-workflow/dynamic-app/service/application-api/application-api.service';

/**
 * Bundle Manager Service provides helper functions and service to work with bundle
 */
@Injectable({ providedIn: 'root' })
export class BundleHelperService {
  constructor(private readonly applicationApiService: ApplicationApiService, private readonly statefulService: StatefulService) {}

  /**
   * Force the bundle to make GET call to bundle api and refresh the bundle in UI
   */
  public refreshBundle(callBack?: () => void): void {
    this.statefulService.wrap('api:consumerId').load(callBack);
  }

  /**
   * Refresh the bundle asynchronously.
   */
  public refreshBundleAsync(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.refreshBundle(() => {
        resolve(true);
      });
    });
  }

  /**
   * Force the bundle to make GET call to bundle api and refresh the bundle in UI
   */
  public refreshOLABundle(callBack?: () => void): void {
    this.statefulService.wrap('ola:consumerId').load(callBack);
  }

  /**
   * Refresh the bundle asynchronously.
   */
  public refreshOLABundleAsync(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.refreshOLABundle(() => {
        resolve(true);
      });
    });
  }

  /**
   * Make a PUT request to bundle api to save the bundle to DDMS
   */
  public saveBundle(cb?: () => void): void {
    const loanNumber = this.statefulService.wrap(`api:loans/0/loanNumber`).valueString;
    if (loanNumber) {
      this.applicationApiService.saveBundleToDDMS(cb);
    }
  }

  /**
   * Make API call to Save the bundle, then make another call to refresh the bundle, onc it is all done
   * it executes call-back function
   */
  public saveAndRefreshBundle(cb?: () => void): void {
    this.saveBundle(() => {
      this.refreshBundle(cb);
    });
  }
}
